import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ParcsJardins from "@/pages/ParcsJardins";
import Nettoyage from "@/pages/Nettoyage";
import Reparations from "@/pages/Reparations";
import APropos from "@/pages/APropos";
import ZoneIntervention from "@/pages/ZoneIntervention";
import LocalCommune from "@/pages/LocalCommune";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/parcs-jardins" element={<ParcsJardins />} />
            <Route path="/nettoyage-exterieur" element={<Nettoyage />} />
            <Route path="/petites-reparations" element={<Reparations />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/zone-intervention" element={<ZoneIntervention />} />
            <Route path="/zone/:slug" element={<LocalCommune />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal type="mentions" />} />
            <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
